(function ($, Drupal) {
  "use strict";

  // Escape user text for regex use.
  function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  // Highlight the typed substring inside the visible menu for a given input.
  function highlightMenu($input) {
    if (!$input || !$input.length) return;

    var term = String($input.val() || "");
    if (!term.length) return;

    // Get the jQuery UI menu widget tied to this input.
    var widget = $input.autocomplete && $input.autocomplete("widget");
    if (!widget || !widget.length || !widget.is(":visible")) return;

    var re = new RegExp("(" + escapeRegExp(term) + ")", "ig");

    widget.find(".ui-menu-item-wrapper, .ui-menu-item > a").each(function () {
      var $line = $(this);
      // Use text() (not html()) to avoid double-wrapping, then escape safely.
      var txt = $line.text();
      var safe = Drupal.checkPlain(txt);
      var html = safe.replace(re, '<span class="ac-match">$1</span>');
      $line.html(html);
    });
  }

  Drupal.behaviors.acHighlight = {
    attach(context) {
      // Track the most recently focused autocomplete input.
      var lastActiveInput = null;

      $(document)
        .on("focusin.acHL", ".webform-autocomplete, .form-autocomplete", function () {
          lastActiveInput = $(this);
        })
        // When jQuery UI opens/refetches, re-highlight.
        .on("autocompleteopen.acHL autocompletesearch.acHL input.acHL",
          ".webform-autocomplete, .form-autocomplete",
          function () {
            var $inp = $(this);
            // Defer so the menu renders first.
            setTimeout(function () { highlightMenu($inp); }, 0);
          });

      // MutationObserver: catch menu creation/updates even if events vary by env.
      // Observe <body> for additions of the jQuery UI menu and its list items.
      var observer = new MutationObserver(function (mutations) {
        // If the menu or its items changed, (re)highlight for the last active input.
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (!(node instanceof HTMLElement)) continue;
            if (
              node.classList.contains("ui-autocomplete") ||
              node.classList.contains("ui-menu") ||
              node.matches(".ui-menu-item, .ui-menu-item-wrapper")
            ) {
              if (lastActiveInput) {
                // A tiny delay allows jQuery UI to finish painting items.
                setTimeout(function () { highlightMenu(lastActiveInput); }, 0);
              }
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    },
  };
})(jQuery, Drupal);
